export default __webpack_public_path__ + "static/media/SidharthSharma.62ec6262.png";